
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.003 2a3.001 3.001 0 00-2.597 1.497L10.412 8.67a1 1 0 101.731 1.002L15.137 4.5a1 1 0 011.732 0l4.288 7.407-1.762-.473a1 1 0 10-.518 1.932l4.098 1.099a1 1 0 001.232-.733l1.092-4.073a1 1 0 10-1.932-.518l-.475 1.77L18.6 3.498A3 3 0 0016.003 2z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.71 23.707a1 1 0 10-1.414-1.414l-3 2.999a.996.996 0 00-.293.698v.009c0 .28.115.533.3.715l2.993 2.993a1 1 0 001.415-1.414l-1.294-1.294h8.585a3 3 0 002.597-4.503l-2.994-5.172a1 1 0 00-1.732 1.002l2.995 5.172A1 1 0 0127.002 25h-8.584l1.293-1.292z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.273 12.632a.998.998 0 00-.774-.097L4.415 13.63a1 1 0 10.518 1.932l1.761-.472-4.287 7.406A3 3 0 005.004 27h5.998a1 1 0 100-2H5.004a1.001 1.001 0 01-.866-1.501l4.292-7.414.475 1.771a1 1 0 001.932-.518l-1.094-4.08a.997.997 0 00-.47-.625z","fill":"currentColor"}})])
          )
        }
      }
    